<template>
  <div>
    <b-table
      id="table-product"
      class="text-center table-list mb-0 bg-white"
      striped
      responsive
      :items="items"
      :fields="fields"
      :per-page="perPage"
      :current-page="pageNo"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template #cell(imageUrl)="data">
        <div class="position-relative">
          <div
            class="square-box b-contain"
            v-bind:style="{
              'background-image': 'url(' + data.item.imageUrl + ')',
            }"
          ></div>
        </div>
      </template>

      <template #cell(productName)="data">
        <p class="product-name" v-html="data.item.productName">
          {{ data.item.productName }}
        </p>
        <p class="product-name mb-0">SKU: {{ data.item.sku }}</p>
      </template>

      <template #cell(totalStock)="data">
        <div>
          <p>{{ data.item.totalStock | numeral("0,0") }}</p>
        </div>
        <a @click="showModalDetail(data.item.productId)">รายละเอียด</a>
      </template>

      <template #cell(onOffStock)="data">
        <p class="mb-0">
          {{ data.item.onlineStock | numeral("0,0") }} /
          {{ data.item.offlineStock | numeral("0,0") }}
        </p>
      </template>

      <template
        v-for="field in fields.slice(4)"
        v-slot:[`cell(${field.key})`]="data"
      >
        <!-- <div :key="field.key">
          {{ getStockBranch(field.key, data.item.branch) | numeral("0,0") }}
        </div> -->
        <div :key="field.key">{{ data.item[field.key] }}</div>
      </template>
    </b-table>
    <b-row class="no-gutters px-3 px-sm-0 bg-white">
      <b-col class="form-inline justify-content-center justify-content-sm-end">
        <div class="d-sm-flex m-3">
          <b-pagination
            v-model="pageNo"
            :total-rows="rows"
            :per-page="perPage"
            @change="pagination"
            class="m-md-0 page-item"
          ></b-pagination>
        </div>
        <b-form-select
          class="mr-sm-3 select-page"
          v-model="perPage"
          @change="handleChangePerpage"
          :options="pageOptions"
        ></b-form-select>
      </b-col>
    </b-row>
    <ModalInventoryLog ref="modalInventoryLog" :productId="productIdDetail" />
  </div>
</template>

<script>
import ModalInventoryLog from "./ModalInventoryLog.vue";
export default {
  components: {
    ModalInventoryLog,
  },
  data() {
    return {
      called: false,
      perPage: 10,
      pageNo: 1,
      isBusy: false,
      items: [],
      rows: 0,
      rowsDetail: 0,
      branch: [],
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      productIdDetail: 0,
      fields: [
        {
          key: "imageUrl",
          label: "ภาพสินค้า",
          class: "w-100px text-nowrap",
        },
        {
          key: "productName",
          label: "ชื่อสินค้า/SKU",
          class: "w-100px text-nowrap",
        },
        {
          key: "totalStock",
          label: "คลังรวม",
          class: "w-100px text-nowrap",
        },
        {
          key: "onOffStock",
          label: "ออนไลน์ / ออฟไลน์",
          class: "w-100px text-nowrap",
        },
      ],
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    async getProductList() {
      await this.axios
        .get(`${this.$baseUrl}/product/Inventory/${this.$route.params.id}`)
        .then((data) => {
          this.rows = data.detail.productInventory.length;
          this.items = [];
          this.branch = data.detail.branchs;

          // data.detail.productInventory;
          for (const i in data.detail.productInventory) {
            var newItem = {
              imageUrl: data.detail.productInventory[i]["imageUrl"],
              productId: data.detail.productInventory[i]["productId"],
              productName: data.detail.productInventory[i]["productName"],
              collection: data.detail.productInventory[i]["collection"],
              totalStock: data.detail.productInventory[i]["totalStock"],
              offlineStock: data.detail.productInventory[i]["offlineStock"],
              onlineStock: data.detail.productInventory[i]["onlineStock"],
              reserve: data.detail.productInventory[i]["reserve"],
              sku: data.detail.productInventory[i]["sku"],
            };
            for (const j in data.detail.productInventory[i]["branchs"]) {
              newItem[data.detail.productInventory[i]["branchs"][j].branchId] =
                data.detail.productInventory[i]["branchs"][j].stock;
            }
            this.items.push(newItem);
          }
          this.isBusy = false;
        });

      this.addFields();
    },
    addFields() {
      if (!this.called) {
        for (const i in this.branch) {
          this.fields.push({
            key: this.branch[i].id.toString(),
            label: this.branch[i].salesChannalName,
            class: "w-100px text-nonwrap",
          });
        }
        this.called = true;
      }
    },
    pagination(Page) {
      this.pageNo = Page;
      this.getProductList();
    },
    handleChangePerpage(value) {
      this.pageNo = 1;
      this.perPage = value;
      this.getProductList();
    },
    showModalDetail(productId) {
      this.productIdDetail = productId;
      this.$nextTick(() => {
        this.$refs.modalInventoryLog.show();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .table > tbody > tr > td {
  min-width: 150px;
  // background-color: #f1f1f1;
  // border-bottom: solid 1px black;
}
.product-name {
  width: 300px;
  text-align: left;
}
a:hover {
  color: #b41bb4;
  text-decoration: underline;
  cursor: pointer;
}
.title-modal {
  font-weight: bold;
  color: black;
}
.cancel-button {
  background-color: white;
  width: 150px;
}
.link-remove-info {
  color: #b41bb4;
  text-decoration: underline;
}
/deep/ .header-modal-class {
  background: #5b57a547;
}
/deep/ .content-modal-class {
  border: 0;
}
// style table detail in modal
/deep/ .table-detail td {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
/deep/ .table-detail th {
  padding-left: 0px !important;
  padding-right: 0px !important;
  border-bottom: 0.5px solid #ccc;
}
</style>
